import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

const LANGUAGES = [
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
  { code: 'it', label: 'Italiano', flag: '🇮🇹' },
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'ar', label: 'العربية', flag: '🇸🇦' },
];

const LangModal = ({ onClose }) => {
  const { t } = useTranslation();
  const { setUserLang } = useAuth();
  const [selected, setSelected] = useState('fr');
  const [saving, setSaving] = useState(false);

  const handleConfirm = async () => {
    setSaving(true);
    await setUserLang(selected);
    setSaving(false);
    onClose();
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      backgroundColor: 'rgba(0,0,0,0.85)',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px'
    }}>
      <div style={{
        backgroundColor: '#111111',
        border: '1px solid #2a2a2a',
        borderRadius: '16px',
        padding: '32px',
        width: '100%',
        maxWidth: '360px',
      }}>
        <h2 style={{ color: 'white', fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: '20px', marginBottom: '8px' }}>
          {t('langModal.title')}
        </h2>
        <p style={{ color: '#888', fontFamily: 'Inter, sans-serif', fontSize: '14px', marginBottom: '24px' }}>
          {t('langModal.subtitle')}
        </p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginBottom: '24px' }}>
          {LANGUAGES?.map((lang) => (
            <button
              key={lang?.code}
              onClick={() => setSelected(lang?.code)}
              style={{
                display: 'flex', alignItems: 'center', gap: '12px',
                padding: '12px 16px',
                borderRadius: '10px',
                border: selected === lang?.code ? '1px solid var(--color-primary)' : '1px solid #2a2a2a',
                backgroundColor: selected === lang?.code ? 'rgba(229,32,42,0.08)' : '#1a1a1a',
                cursor: 'pointer',
                color: 'white',
                fontFamily: 'Inter, sans-serif',
                fontSize: '15px',
                fontWeight: selected === lang?.code ? 600 : 400,
              }}
            >
              <span style={{ fontSize: '20px' }}>{lang?.flag}</span>
              <span>{lang?.label}</span>
            </button>
          ))}
        </div>
        <button
          onClick={handleConfirm}
          disabled={saving}
          style={{
            width: '100%',
            padding: '14px',
            borderRadius: '10px',
            border: 'none',
            backgroundColor: 'var(--color-primary)',
            color: 'white',
            fontFamily: 'var(--font-heading)',
            fontWeight: 700,
            fontSize: '15px',
            cursor: saving ? 'not-allowed' : 'pointer',
            opacity: saving ? 0.7 : 1,
          }}
        >
          {saving ? '...' : t('langModal.confirm')}
        </button>
      </div>
    </div>
  );
};

export default LangModal;
